import React from 'react';

import PropTypes from 'prop-types';

export const invoice = ({ fillColor }) => (
    <svg
        viewBox='0 0 19 24'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <defs>
            <path
                d='M12.2181818,10.8 C11.5636364,10.8 11.1272727,10.4181818 11.0181818,9.81818182 L9.65454545,9.81818182 C9.70909091,11.0181818 10.4727273,11.8363636 11.6181818,12.0545455 L11.6181818,12.9272727 L12.7090909,12.9272727 L12.7090909,12.1090909 C13.8545455,11.9454545 14.5090909,11.2363636 14.5090909,10.1454545 C14.5090909,9 13.9636364,8.34545455 12.8727273,8.07272727 L11.7272727,7.74545455 C11.3454545,7.63636364 11.0181818,7.47272727 11.0181818,7.09090909 C11.0181818,6.6 11.4,6.38181818 11.9454545,6.38181818 C12.3818182,6.38181818 12.8727273,6.6 12.9818182,7.03636364 L14.3454545,7.03636364 C14.2363636,6.05454545 13.6363636,5.34545455 12.6545455,5.12727273 L12.6545455,4.2 L11.5636364,4.2 L11.5636364,5.07272727 C10.5272727,5.18181818 9.70909091,5.83636364 9.70909091,7.03636364 C9.70909091,8.07272727 10.2545455,8.78181818 11.2909091,9.05454545 L12.4363636,9.38181818 C12.9272727,9.49090909 13.1454545,9.70909091 13.1454545,10.0909091 C13.2,10.5818182 12.7636364,10.8 12.2181818,10.8 Z M5.23636364,9.16363636 L6.05454545,9.16363636 L7.69090909,12 L9.21818182,12 L7.52727273,9.10909091 C8.50909091,8.89090909 9,8.18181818 9,7.14545455 C9,5.89090909 8.23636364,5.12727273 6.81818182,5.12727273 L3.92727273,5.12727273 L3.92727273,12 L5.23636364,12 L5.23636364,9.16363636 L5.23636364,9.16363636 Z M5.23636364,6.43636364 L6.87272727,6.43636364 C7.36363636,6.43636364 7.69090909,6.70909091 7.69090909,7.2 C7.69090909,7.69090909 7.36363636,7.90909091 6.87272727,7.90909091 L5.23636364,7.90909091 L5.23636364,6.43636364 Z M17.4545455,0 L1.09090909,0 C0.490909091,0 0,0.490909091 0,1.09090909 L0,22.9090909 C0,23.5090909 0.490909091,24 1.09090909,24 L9.43636364,24 C10.2545455,24 10.9090909,23.5636364 11.2909091,22.9090909 L17.1272727,17.4545455 C17.9454545,17.1272727 18.4909091,16.3636364 18.4909091,15.4363636 L18.4909091,1.09090909 C18.5454545,0.490909091 18.0545455,0 17.4545455,0 Z M11.6181818,19.6363636 L11.6181818,17.6181818 L13.8,17.6181818 L11.6181818,19.6363636 Z M16.3636364,15.2181818 L16.1454545,15.4363636 L10.5272727,15.4363636 C9.92727273,15.4363636 9.43636364,15.9272727 9.43636364,16.5272727 L9.43636364,21.8181818 L2.18181818,21.8181818 L2.18181818,2.18181818 L16.3636364,2.18181818 L16.3636364,15.2181818 Z'
                id='path-invoice'
            />
        </defs>
        <g
            id='Symbols'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
        >
            <mask id='mask-2' fill='white'>
                <use xlinkHref='#path-invoice' />
            </mask>
            <use
                id='Mask'
                fill={fillColor}
                fillRule='nonzero'
                xlinkHref='#path-invoice'
            />
        </g>
    </svg>
);

invoice.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default invoice;
